import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

import { useUserId } from 'features/user/hooks/useUserId';

export type TMutationParams = {
  targetUserId?: string;
  challengeIds: string[];
};

type TUseAddChallengesToSprint = {
  options?: UseMutationOptions<
    Record<string, never>,
    unknown,
    TMutationParams
  > & {
    enabled?: boolean;
  };
};

export const useAddChallengesToSprint = ({
  options,
}: TUseAddChallengesToSprint = {}) => {
  const userId = useUserId();
  const { request } = useMutationHTTPRequest();

  return useMutation(
    async ({ challengeIds }: TMutationParams) =>
      await request({
        url: `/api/timeline/challenges/add-to-sprint`,
        body: {
          targetUserId: userId,
          challengeIds,
        },
      }),
    {
      ...options,
    }
  );
};
